import { createClient } from '@supabase/supabase-js'

// Use standard React environment variables (available at build time)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Check your environment variables.')
  console.log('REACT_APP_SUPABASE_URL:', supabaseUrl)
  console.log('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Add global error handler to catch browser extension interference
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    // Filter out browser extension errors that might interfere with auth
    if (event.message && (
      event.message.includes('message channel closed') ||
      event.message.includes('Extension context invalidated') ||
      (event.filename && event.filename.includes('extension://'))
    )) {
      console.warn('Browser extension error detected and ignored:', event.message);
      event.preventDefault();
      return false;
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    // Handle unhandled promise rejections from browser extensions
    if (event.reason && event.reason.message && (
      event.reason.message.includes('message channel closed') ||
      event.reason.message.includes('Extension context invalidated')
    )) {
      console.warn('Browser extension promise rejection detected and ignored:', event.reason.message);
      event.preventDefault();
    }
  });
}
